import { OrganizationItem } from "@/endpoints/dryp/backoffice";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FC, useState } from "react";
import { Loader2, Plus } from "lucide-react";
import { ROLE_OPTIONS } from "./constants";

interface AddOrganizationProps {
	availableOrganizations: OrganizationItem[];
	onAdd: (organizationId: string, role: string) => Promise<void>;
	loading: boolean;
}

export const AddOrganization: FC<AddOrganizationProps> = ({ availableOrganizations, onAdd, loading }) => {
	const [selectedOrganizationId, setSelectedOrganizationId] = useState<string>("");
	const [selectedRole, setSelectedRole] = useState<string>("User");

	if (availableOrganizations.length === 0) return null;

	const handleAdd = async () => {
		if (!selectedOrganizationId) return;
		await onAdd(selectedOrganizationId, selectedRole);
		setSelectedOrganizationId("");
		setSelectedRole("User");
	};

	return (
		<div className="flex items-center gap-2">
			<Select value={selectedOrganizationId} onValueChange={setSelectedOrganizationId}>
				<SelectTrigger className="flex-1">
					<SelectValue placeholder="Select organization" />
				</SelectTrigger>
				<SelectContent>
					{availableOrganizations.map(organization => (
						<SelectItem key={organization.id} value={organization.id}>
							{organization.name}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
			<Select value={selectedRole} onValueChange={setSelectedRole}>
				<SelectTrigger className="w-32">
					<SelectValue />
				</SelectTrigger>
				<SelectContent>
					{ROLE_OPTIONS.map(role => (
						<SelectItem key={role.value} value={role.value}>
							{role.label}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
			<Button variant="outline" size="icon" onClick={handleAdd} disabled={!selectedOrganizationId || loading}>
				{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Plus className="h-4 w-4" />}
			</Button>
		</div>
	);
};
